import React, { Component } from "react";

export default class Items extends Component {
  render() {
    return (
      <div className='itemBucket'>
        <h3>DONATE ALMOST ANYTHING</h3>
        <div className='container itemGrid'>
          <div className='row'>
            <div className='col-sm-3'>
              <div className='card'>
                <div className='card-body'>
                  <h5 className='card-title'>
                    Special title treatment
                  </h5>
                  <p className='card-text'>
                    With supporting text below as a natural lead-in to
                    additional content.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='card'>
                <div className='card-body'>
                  <h5 className='card-title'>
                    Special title treatment
                  </h5>
                  <p className='card-text'>
                    With supporting text below as a natural lead-in to
                    additional content.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='card'>
                <div className='card-body'>
                  <h5 className='card-title'>
                    Special title treatment
                  </h5>
                  <p className='card-text'>
                    With supporting text below as a natural lead-in to
                    additional content.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='card'>
                <div className='card-body'>
                  <h5 className='card-title'>
                    Special title treatment
                  </h5>
                  <p className='card-text'>
                    With supporting text below as a natural lead-in to
                    additional content.
                  </p>
                </div>
              </div>
            </div>

            <div className='col-sm-3'>
              <div className='card'>
                <div className='card-body'>
                  <h5 className='card-title'>
                    Special title treatment
                  </h5>
                  <p className='card-text'>
                    With supporting text below as a natural lead-in to
                    additional content.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='card'>
                <div className='card-body'>
                  <h5 className='card-title'>
                    Special title treatment
                  </h5>
                  <p className='card-text'>
                    With supporting text below as a natural lead-in to
                    additional content.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='card'>
                <div className='card-body'>
                  <h5 className='card-title'>
                    Special title treatment
                  </h5>
                  <p className='card-text'>
                    With supporting text below as a natural lead-in to
                    additional content.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='card'>
                <div className='card-body'>
                  <h5 className='card-title'>
                    Special title treatment
                  </h5>
                  <p className='card-text'>
                    With supporting text below as a natural lead-in to
                    additional content.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
